import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ApartmentsDetailsAmenitiesElement from './ApartmentsDetailsAmenitiesElement';
import { GetApartmentListItemAmenityResponseDto } from '@/features/apartments/types/apartments-dto';
import { cn } from '@/lib/utils';

type Props = {
	amenities?: GetApartmentListItemAmenityResponseDto[];
	isMobile?: boolean;
};

const ApartmentsDetailsAmenities: FC<Props> = ({ amenities, isMobile }) => {
	const { t } = useTranslation();

	const groupedAmenities =
		amenities?.reduce((acc, el) => {
			const key = el.amenityGroup ?? 'unknown';
			acc[key] = acc[key] || [];
			acc[key].push(el);
			return acc;
		}, {} as Record<string, GetApartmentListItemAmenityResponseDto[]>) ??
		{};

	return (
		<div className='flex flex-col gap-4 select-none'>
			<div className='flex gap-2'>
				<h3 className={cn(isMobile && 'text-base')}>
					{t(
						'main.apartments.components.details.list.amenities.title',
					)}
				</h3>
			</div>
			<div
				className={cn(
					'p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10 text-sm',
					isMobile && 'p-0 border-0 bg-popover-30',
				)}>
				{Object.entries(groupedAmenities).map(([key, value]) => (
					<div
						key={key}
						className='flex flex-col gap-2'>
						<h5
							className={cn(
								'text-popover-800',
								isMobile && 'text-sm',
							)}>
							{key}
						</h5>
						<div className='flex flex-wrap gap-2'>
							{value.map((item, index) => (
								<ApartmentsDetailsAmenitiesElement
									key={index}
									label={item.description}
									icon={item.amenitySvg}
								/>
							))}
						</div>
					</div>
				)) && (
					<span className='text-sm text-popover-800'>
						{t(
							'main.apartments.components.details.list.amenities.noData',
						)}
					</span>
				)}
			</div>
		</div>
	);
};

export default ApartmentsDetailsAmenities;
